import gql from "graphql-tag"

const DELETE_CUSTOM_EMAIL_TEMPLATE = gql`
  mutation deleteUserEmailTemplate($input: DeleteCustomEmailTemplateInput!) {
    deleteCustomEmailTemplate(input: $input) {
      success
      error
    }
  }
`

const UPDATE_CUSTOM_EMAIL_TEMPLATE = gql`
  mutation updateEmailTemplate($input: UpdateEmailTemplateInput!) {
    updateEmailTemplate(input: $input) {
      success
      error
    }
  }
`

export { DELETE_CUSTOM_EMAIL_TEMPLATE, UPDATE_CUSTOM_EMAIL_TEMPLATE }